import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/contexts/LanguageContext';

type FAQLinkProps = Omit<LinkProps, 'to' | 'children'> & {
  children?: React.ReactNode;
};

/**
 * Single, language-aware FAQ link. Resolves to `/faq` for English users and
 * `/faq/{locale}` for everyone else, with the label coming from the active
 * translation. The user never has to choose between 11 URLs.
 */
const FAQLink = ({ children, ...rest }: FAQLinkProps) => {
  const { currentLanguage } = useLanguage();
  const { t } = useTranslation();
  const to = currentLanguage === 'en' ? '/faq' : `/faq/${currentLanguage}`;
  return (
    <Link to={to} {...rest}>
      {children ?? t('faq.linkLabel')}
    </Link>
  );
};

export default FAQLink;
